<template>
  <div class="account-page">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <!-- Page Content -->
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-8 offset-md-2">
              <!-- Account Content -->
              <div class="account-content">
                <div class="row align-items-center justify-content-center">
                  <div class="col-md-7 col-lg-6 login-left">
                    <img
                      src="@/assets/img/login-banner.png"
                      class="img-fluid"
                      alt="Login Banner"
                    />
                  </div>
                  <div class="col-md-12 col-lg-6 login-right">
                    <form @submit.prevent="updatePassword()">
                      <div class="form-group">
                        <label>New Password</label>
                        <input
                          type="password"
                          v-model="user.password"
                          required
                          class="form-control"
                        />
                      </div>
                      <div class="form-group">
                        <label>Confirm Password</label>
                        <input
                          type="password"
                          v-model="user.confirm_password"
                          required
                          class="form-control"
                        />
                        <p class="No_data text-left" v-if="this.validatePass()">
                          Password and confirm password does not match
                        </p>
                      </div>
                      <div class="submit-section d-flex justify-content-center">
                        <button
                          :disabled="disabled"
                          type="submit"
                          class="btn btn-primary submit-btn"
                        >
                          Change Password
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <!-- /Account Content -->
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
      <layout-footer></layout-footer>
    </div>
  </div>
</template>

<script>
import CommonApi from "../../services/CommonApi";
export default {
  data() {
    return {
      user: {
        password: "",
        confirm_password: "",
      },
      disabled: true,
      username: localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo")).user
        : null,
    };
  },
  computed: {
    currentPath() {
      return this.$route.name;
    },
  },
  watch: {
    user: {
      handler() {
        this.validateForm();
      },
      deep: true,
    },
  },
  methods: {
    /* Form Validation */
    validateForm() {
      if (
        this.user.password === "" ||
        this.user.confirm_password === "" ||
        this.validatePass()
      ) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },

    /* Check if both password are same */
    validatePass() {
      if (this.user.password !== this.user.confirm_password) {
        return true;
      } else {
        return false;
      }
    },

    /* Update Password */
    async updatePassword() {
      let data = {
        user: this.username,
        password: this.user.confirm_password,
      };
      await CommonApi.post_data(
        "sahaj.bklogin.reset_password",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          });
          localStorage.removeItem("userInfo");
          this.user.password = "";
          this.user.confirm_password = "";
          this.$router.push("/login");
        } else {
          console.log("data", res);
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res._server_messages,
            showConfirmButton: true,
          });
        }
      });
    },
  },
  destroyed() {
    localStorage.removeItem("userInfo");
  },
};
</script>


// WEBPACK FOOTER //
// src/components/kneexpert/CommonChangePassword.vue